import { ref } from 'vue';
import { useUserStore } from '~/composables/useUserStore';
import {
    fetchTags,
    fetchTagById,
    postTag,
    updateTag,
    removeTag, updateTagOrders, updateReadOrders
} from '~/api/tagApi';

const tags = ref<any[]>([]);

export function useTagStore() {
    const { token } = useUserStore();

    const loadTags = async (query = {}) => {
        try {
            tags.value = await fetchTags(query);
        } catch (error) {
            console.error('Failed to load tags:', error);
        }
    };

    const loadTagById = async (id: string) => {
        try {
            return await fetchTagById(id);
        } catch (error) {
            console.error('Failed to load tag:', error);
        }
    };

    const newTag = async (payload: any) => {
        try {
            const response = await postTag(payload, token.value);
            return response;
        } catch (error) {
            console.error('Failed to create tag:', error);
        }
    };

    const patchTag = async (payload: any, id: string) => {
        try {
            const response = await updateTag(payload, id, token.value);
            return response;
        } catch (error) {
            console.error('Failed to update tag:', error);
        }
    };

    const deleteTag = async (id: string) => {
        try {
            const response = await removeTag(id, token.value);
            return response;
        } catch (error) {
            console.error('Failed to delete tag:', error);
        }
    };

    const updateTagOrder = async (updatedTags: any[]) => {
        try {
            const response = await updateTagOrders({tags: updatedTags}, token.value);
            return response;
        } catch (error) {
            console.error('Failed to update tag order:', error);
        }
    };
    const updateReadOrder = async (updatedReads: any[]) => {
        try {
            const response = await updateReadOrders({reads: updatedReads}, token.value);
            return response;
        } catch (error) {
            console.error('Failed to update tag order:', error);
        }
    };

    return {
        tags,
        loadTags,
        loadTagById,
        newTag,
        patchTag,
        deleteTag,
        updateTagOrder,
        updateReadOrder
    };
}
